/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AbstractFormComponent,
  BuilderNavigationService,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
  JobDetailsModel,
} from '@gh/builder-shared';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { translationTuple } from '@gh/core-mls';

import { assign } from 'lodash';

import { JobDetailsTabBusinessService } from '../../../resources/job-details-tab/job-details-tab-business.service';
import { JobInsurance } from '../../../resources/job-details-tab/job-details-tab-model';
import { JobDetailsInsuranceTabFormState } from './job-details-insurance-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-job-details-insurance-tab',
  templateUrl: 'job-details-insurance-tab.component.html',
  providers: [JobDetailsInsuranceTabFormState],
})
export class JobDetailsInsuranceTabComponent extends AbstractFormComponent<JobInsurance> implements OnInit {
  insurance: JobInsurance;
  jobId: ID;

  constructor(public form: JobDetailsInsuranceTabFormState,
              private route: ActivatedRoute,
              private model: JobDetailsModel,
              private businessService: JobDetailsTabBusinessService,
              private pipelines: FormActionPipelines,
              private actions: CommonActions,
              public navigationService: BuilderNavigationService) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<JobInsurance>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<JobInsurance>) =>
        this.businessService.updateInsurance({
          ...state.form.submitValue,
          id: this.insurance.id,
          insuranceCompanyId: this.insurance.insuranceCompanyId,
          insuranceCompanyName: this.insurance.insuranceCompanyName,
          insuranceAmount: this.insurance.insuranceAmount,
          version: this.insurance.version,
        })),
      finish: (state: FormFlowState<JobInsurance>) => {
        const { value } = state;
        this.insurance = value;
        this.form.build(value);
      },
    });
  }

  ngOnInit(): void {
    const { insurance, jobId } = getRouteInitData(this.route);
    assign(this, { insurance, jobId });

    this.form.build(insurance);
  }

  onPolicyNumberChange(): void {
    this.form.onPolicyNumberChange();
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.jobId,
      entityType: 'JOB',
      label: translationTuple('lbl_job_number_with_param', { number: String(this.model.jobNumber) }),
    });
  }
}
